export const social = [
  {
    id: 1,
    name: 'Facebook',
    image: 'https://proj-assets.onedio.com/sunum/facebook.svg',
    url: 'https://www.facebook.com/onediocom'
  },
  {
    id: 2,
    name: 'Instagram',
    image: 'https://proj-assets.onedio.com/sunum/instagram.svg',
    url: 'https://www.instagram.com/onediocom/'
  },
  {
    id: 3,
    name: 'X',
    image: 'https://proj-assets.onedio.com/sunum/twitter-x.svg',
    url: 'https://twitter.com/onediocom'
  },
  {
    id: 4,
    name: 'Tiktok',
    image: 'https://proj-assets.onedio.com/sunum/tiktok.svg',
    url: 'https://www.tiktok.com/@onedio.com'
  },
  {
    id: 5,
    name: 'Youtube',
    image: 'https://proj-assets.onedio.com/sunum/youtube.svg',
    url: 'https://www.youtube.com/@onediotube'
  },
  {
    id: 6,
    name: 'Linkedin',
    image: 'https://proj-assets.onedio.com/sunum/linkedin.svg',
    url: 'https://www.linkedin.com/company/onedio/mycompany/'
  },
]
